import * as ko from "knockout";
import * as _ from "lodash";
import * as $ from "jquery";

import { Popup, PopupWithPlayload } from "./popup";
import { Application } from "../application";
import { PopupType } from "./popupType";

export class PopupsManager {
    public popups = ko.observableArray<Popup>([]);

    constructor(private app: Application) {

    }

    register<T>(type: PopupType, component: string) {

        let popup = new PopupWithPlayload<T>(this.app, type, component);

        this.popups.push(popup);

        return popup;
    }
    

    show<T>(type: PopupType, keepOpenedOthers: boolean, data?: T) : JQueryPromise<any> {

        let popup = _.find<PopupWithPlayload<T>>(this.popups(), item => {
            return item.type == type;
        });
        
        if (!popup) {        
            return $.Deferred().reject().promise();
        }

        if(popup.visible()){
            popup.visible(false);
            return $.Deferred().reject().promise();
        }
            

        if(!popup.deferred)
            popup.deferred = $.Deferred();

        popup.reject = true;
        popup.data = data;

        if(!keepOpenedOthers) {
            this.popups().forEach(x => {
                if(x == popup)
                    return;
                
                x.visible(false);
            });
        }

        let dfd = popup.deferred;

        popup.visible(true);

        return dfd.promise();
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/popups/popupsManager.ts